import { Controller } from "@hotwired/stimulus"
import * as Routes from "routes"

export default class TicketMappingsController extends Controller {
  static targets = [
    "serviceBoard",
    "defaultCompany",
    "type",
    "typeName",
    "subtype",
    "subtypeName",
    "item",
    "itemName",
    "completeStatus",
    "completeStatusName",
  ]

  selectOptions(url, placeholder_text) {
    return {
      placeholder: placeholder_text,
      allowClear: true,
      theme: "bootstrap",
      width: "100%",
      ajax: {
        url: url,
        dataType: "json",
        data: {
          service_board_id: this.serviceBoardTarget.value,
          type_id: this.typeTarget.value,
          subtype_id: this.subtypeTarget.value
        },
        delay: 150,
        error: this.handleAjaxError
      }
    }
  }

  setupSelects() {
    $(this.typeTarget).select2(this.selectOptions(Routes.types_account_integrations_connect_wise_path(huntressData.connect_wise), "Select a Type"))
    $(this.subtypeTarget).select2(this.selectOptions(Routes.subtypes_account_integrations_connect_wise_path(huntressData.connect_wise), "Select a Subtype"))
    $(this.itemTarget).select2(this.selectOptions(Routes.items_account_integrations_connect_wise_path(huntressData.connect_wise), "Select an Item"))
    if (this.hasCompleteStatusTarget) {
      $(this.completeStatusTarget).select2(this.selectOptions(Routes.statuses_account_integrations_connect_wise_path(huntressData.connect_wise), "Do not update"))
    }
  }

  connect() {
    this.setupSelects()
    $(this.serviceBoardTarget).select2({
      placeholder: "Select a Board",
      allowClear: true,
      theme: "bootstrap",
      width: "100%",
    })
    $(this.serviceBoardTarget).on("select2:select select2:unselecting", this.handleChange.bind(this))

    $(this.typeTarget).on("select2:select select2:unselecting", this.handleChange.bind(this))
    if(this.hasTypeNameTarget) {
      $(this.typeTarget).on("select2:select select2:unselecting", this.syncHiddenField.bind(this, this.typeNameTarget))
    }

    $(this.subtypeTarget).on("select2:select select2:unselecting", this.handleChange.bind(this))
    if (this.hasSubtypeNameTarget) {
      $(this.subtypeTarget).on("select2:select select2:unselecting", this.syncHiddenField.bind(this, this.subtypeNameTarget))
    }
    if (this.hasItemNameTarget) {
      $(this.itemTarget).on("select2:select select2:unselecting", this.syncHiddenField.bind(this, this.itemNameTarget))
    }
    if (this.hasCompleteStatusNameTarget) {
      $(this.completeStatusTarget).on("select2:select select2:unselecting", this.syncHiddenField.bind(this, this.completeStatusNameTarget))
    }
  }

  syncHiddenField(target, event) {
    target.value = event.target.selectedOptions[0].textContent
  }

  handleChange(event) {
    let HIERARCHY_MAPPING = {
      1: this.serviceBoardTarget,
      2: this.typeTarget,
      3: this.subtypeTarget,
      4: this.itemTarget,
    }

    let HIDDEN_FIELD_HEIRARCHY_MAPPING = {}

    if (this.hasTypeNameTarget) {
      HIDDEN_FIELD_HEIRARCHY_MAPPING[2] = this.typeNameTarget
    }
    if (this.hasSubtypeNameTarget) {
      HIDDEN_FIELD_HEIRARCHY_MAPPING[3] = this.subtypeNameTarget
    }
    if (this.hasItemNameTarget) {
      HIDDEN_FIELD_HEIRARCHY_MAPPING[4] = this.itemNameTarget
    }
    if (this.hasCompleteStatusTarget) {
      HIERARCHY_MAPPING[5] = this.completeStatusTarget
      if (this.hasCompleteStatusNameTarget) {
        HIDDEN_FIELD_HEIRARCHY_MAPPING[5] = this.completeStatusNameTarget
      }
    }

    let hierarchy_id = parseInt(event.currentTarget.dataset.hierarchyId)
    for (let [position, target] of Object.entries(HIERARCHY_MAPPING)) {
      const pos = parseInt(position)
      target.disabled = false
      if (pos > hierarchy_id) {
        $(target).empty()
        if(HIDDEN_FIELD_HEIRARCHY_MAPPING[pos] !== "undefined") {
          $(HIDDEN_FIELD_HEIRARCHY_MAPPING[pos]).val("")
        }
        if (pos > (hierarchy_id + 1) && (pos !== 5)) {
          target.disabled = true
        }
      }
    }

    this.setupSelects()
  }

  handleAjaxError(xhr, status, error) {
    if (status === "abort") { return }

    let message = ""
    if (status === "timeout") {
      message = "Request timed out"
    } else {
      message = (xhr.responseJSON && xhr.responseJSON.error && xhr.responseJSON.error.message) ||
        ("An unknown error occurred: " + status + " (" + xhr.status + ")")
    }

    $("main").prepend(
      $("<div/>", {class: "alert alert-danger alert-dismissible animated fadeIn"})
        .append(
          $("<button>", {class: "close", "data-dismiss": "alert"}).text("×"),
          $("<span>").text(message)
        )
    )
  }
}
